import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'shortDate' })
export class ShortDatePipe implements PipeTransform {

    transform(value: Date) {

        if (value) {
            if (typeof value == 'object' && typeof value.getFullYear == 'function') {
                return (value.getMonth() + 1) + '/' + value.getDate() + '/' + value.getFullYear();
            }

            var dateString = value.toString();
            return this.parseDate(dateString);
        }
        return undefined;
    }

    parseDate(dateString: string): string {
        if (dateString.indexOf('/') > 0) {
            return dateString;
        }
        var n = dateString.indexOf('-');
        var y = dateString.indexOf('-', n + 1);
        var parseDate = dateString.substring(0, y + 3);
        var parseYear = parseDate.substring(0, 4);
        var parseMonth = parseDate.substring(5, 7);
        var parseDay = parseDate.substring(8, 11);
        if (parseYear === '0001') {
            return null;
        }
        var shortDate = parseMonth + '/' + parseDay + '/' + parseYear;
        return shortDate;
    }
}
